import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'risk_factor/getEach?';
const allUrl = 'risk_factor/get?';
const storeUrl = 'risk_factor/store';
const updateUrl = 'risk_factor/update?';
const deleteUrl = 'risk_factor/delete?';

const state = {
  riskFactors: [],
  riskFactor: {},
};
const getters = {};
const mutations = {
  SET_RISK_FACTORS(state, payload) {
    state.riskFactors = payload.data.data
  },
  SET_RISK_FACTOR(state, payload) {
    state.riskFactor = payload.data.data
  },
  ADD_RISK_FACTOR(state, payload) {
    state.riskFactors.push(payload.data.data)
  },
  REMOVE_RISK_FACTOR(state, payload) {
    const riskFactors = state.riskFactors.filter((riskFactor) => riskFactor.id != payload.id)
    state.riskFactors = [...riskFactors]
  }
};

const actions = {
  async getRiskFactors({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_RISK_FACTORS", response);
  },
  async getRiskFactor({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_RISK_FACTOR", response);
  },
  async createRiskFactor({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_RISK_FACTOR", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async updateRiskFactor(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async deleteRiskFactor({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_RISK_FACTOR", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
